import { ILMapLayer } from './LMap';
import * as L from 'leaflet';
export class LMapAdapter implements ILMapLayer {
    public title: string;
    public url: string;
    public attribution: string;
    constructor(title: string, layer: ILMapLayer) {
        this.title = title;
        this.url = layer.url;
        this.attribution = layer.attribution;
    }
    public getTileLayer() {
        return L.tileLayer(this.url, { attribution: this.attribution });
    }
}
